import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import { Chart } from "chart.js";
import {
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import PageHeading from "../../components/PageHeading";
import useScreenSize, { BreakPoint } from "../../hooks/useScreenSize";
import useStore from "../../store/store";
import statsService from "../../services/stats";
import { LinkButton } from "../../controls";
import moment from "moment";

Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
};

function TransactionChart() {
  const size = useScreenSize();
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Debit",
        maxBarThickness: 40,
        data: [],
        backgroundColor: "rgba(54, 162, 235, 0.5)",
      },
      {
        label: "Credit",
        maxBarThickness: 40,
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
    ],
  });

  const { token, setIsLoading, setErrorMessage } = useStore((state) => state);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setIsLoading(true);
    statsService
      .getData(token, {
        interval: "weekly",
        week: moment().format("W"),
        month: moment().format("MMMM"),
        year: moment().format("YYYY"),
      })
      .then((result) => {
        if (result.error) {
          setErrorMessage(result.error);
          setIsLoading(false);
          return;
        }

        const debitArr = [];
        const creditArr = [];

        const last7DaysStartDate = moment().subtract(6, "days");

        for (let i = 0; i < 7; i++) {
          const currentDate = moment(last7DaysStartDate).add(i, "days");
          const dayNumber = parseInt(currentDate.format("D"));

          const dataForDay = result.data.find(
            (k) => parseInt(moment(k._id).format("D")) === dayNumber
          );

          if (dataForDay) {
            debitArr.push({
              _id: dayNumber,
              total: dataForDay.debit,
            });
            creditArr.push({
              _id: dayNumber,
              total: dataForDay.credit,
            });
          } else {
            debitArr.push({ _id: dayNumber, total: 0 });
            creditArr.push({ _id: dayNumber, total: 0 });
          }
        }

        setData({
          labels: debitArr.map((k) => k._id),
          datasets: [
            {
              maxBarThickness: 40,
              data: debitArr.map((k) => k.total),
              borderColor: "rgb(54, 162, 235)",
              backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
            {
              maxBarThickness: 40,
              data: creditArr.map((k) => k.total),
              borderColor: "rgb(54, 162, 235)",
              backgroundColor: "rgba(54, 162, 235, 0.5)",
            },
          ],
        });
        setIsLoading(false);
      });
  };

  let height =
    size.screen === BreakPoint.xs || size.screen === BreakPoint.s ? 300 : 500;
  let padding =
    size.screen === BreakPoint.xs || size.screen === BreakPoint.s ? 0 : 1;

  return (
    <>
      <Grid container>
        <Grid item xs={6} md={6} sx={{ mb: 2, mt: 2 }}>
          <PageHeading text="Details" />
        </Grid>
        <Grid item xs={6} md={6} sx={{ mb: 2, mt: 2 }}>
          <LinkButton text="See details" to="/chart" float="right" mt={7} />
        </Grid>

        <Grid item xs={12} md={12}>
          <Box sx={{ pl: padding, pr: padding, height: height }}>
            <Bar options={options} data={data} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default TransactionChart;
